import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

// Components
import { Text } from '../../..'
import OnboardingButton from '../Steps/Button/OnboardingButton'

import styles from './Goal.module.scss'

const propTypes = {
  onClick: PropTypes.func.isRequired,
  selectedGoal: PropTypes.string,
  goal: PropTypes.string.isRequired,
  copy: PropTypes.string.isRequired,
  icon: PropTypes.func.isRequired,
  className: PropTypes.string
}

const Goal = ({ onClick, selectedGoal, goal, copy, icon: GoalIcon, className }) => (
  <OnboardingButton
    data-qa={goal}
    key={goal}
    selected={selectedGoal === goal}
    className={styles.goalButton}
    onClick={() => onClick(goal)}
  >
    <div className={classnames(styles.goalContent, className)}>
      <div className={styles.goalIcon}>
        <GoalIcon className={styles.icon} />
      </div>
      <div className={styles.goalLabel}>
        <Text className={styles.label} size='m' variant='neutralCool' variantCount='900'>
          {copy}
        </Text>
      </div>
    </div>
  </OnboardingButton>
)

Goal.propTypes = propTypes

export default Goal
